import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

// ACTIONS
const productDevelopmentRequested = createAction('productDevelopment/requested')
const productDevelopmentRequestFailed = createAction('productDevelopment/requestFailed')
const productDevelopmentReceived = createAction('productDevelopment/received')

const productDevelopmentAdded = createAction('productDevelopment/added')

const productDevelopmentRemoved = createAction('productDevelopment/removed')

const productDevelopmentSendRequested = createAction('productDevelopment/sendRequested')
const productDevelopmentSendReceived = createAction('productDevelopment/sendReceived')
const productDevelopmentSendRequestFailed = createAction('productDevelopment/sendRequestFailed')

// REDUCER
export const initialState = {
  data: [],
  toDevelop: [],
  loading: false,
  sendProductDevelopmentLoading: false,
  loadSuccess: false,
  success: false,
  sendProductDevelopmentSuccess: false
}

const productDevelopmentReducer = createReducer(initialState, {
  [productDevelopmentRequested.type]: (state) => {
    state.loading = true
    state.success = false
    state.loadSuccess = false
  },
  [productDevelopmentReceived.type]: (state, action) => {
    state.loading = false
    state.loadSuccess = true
    state.data = action.payload.data
  },
  [productDevelopmentRequestFailed.type]: (state, action) => {
    state.loading = false
    state.success = false
    state.loadSuccess = false
    state.toDevelop = []
    toast.error(action.payload.message)
  },
  [productDevelopmentAdded.type]: (state, action) => {
    state.toDevelop = [...state.toDevelop, action.payload]
  },
  [productDevelopmentRemoved.type]: (state, action) => {
    state.toDevelop = state.toDevelop.filter((product) => product !== action.payload)
  },
  // Send product development
  [productDevelopmentSendRequested.type]: (state) => {
    state.sendProductDevelopmentLoading = true
    state.sendProductDevelopmentSuccess = false
  },
  [productDevelopmentSendReceived.type]: (state, action) => {
    state.sendProductDevelopmentLoading = false
    state.sendProductDevelopmentSuccess = true
    state.data = action.payload.data
    state.toDevelop = []
  },
  [productDevelopmentSendRequestFailed.type]: (state, action) => {
    state.sendProductDevelopmentLoading = false
    state.sendProductDevelopmentSuccess = false
    toast.error(action.payload.message)
  }
})

export default productDevelopmentReducer

// PUBLIC ACTIONS

export const loadProductDevelopment = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/product_development`,
      onStart: productDevelopmentRequested.type,
      onSuccess: productDevelopmentReceived.type,
      onError: productDevelopmentRequestFailed.type
    })
  )
}

export const addProductDevelopment = (productType) => productDevelopmentAdded(productType)

export const removeProductDevelopment = (productType) => productDevelopmentRemoved(productType)

export const sendProductDevelopment = () => (dispatch, getState) => {
  const state = getState()
  const id = gameIdSelector(state)
  const productTypes = state.productDevelopment.toDevelop

  dispatch(
    apiCallBegan({
      url: `/games/${id}/product_development/develop`,
      method: 'patch',
      data: { product_types: productTypes },
      onStart: productDevelopmentSendRequested.type,
      onSuccess: productDevelopmentSendReceived.type,
      onError: productDevelopmentSendRequestFailed.type
    })
  )
}
